export default __webpack_public_path__ + "static/media/Southwest.0b13c984.svg";